import { createFileRoute } from "@tanstack/react-router";
import HelpingSpouseWithDepression from "@/pages/HelpingSpouseWithDepression";
export const Route = createFileRoute("/helping-spouse-with-depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Helping Spouse With Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "When your spouse has depression, it affects the whole family. Learn how to help and what treatment options exist in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Helping Spouse With Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "When your spouse has depression, it affects the whole family. Learn how to help and what treatment options exist in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/helping-spouse-with-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/helping-spouse-with-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HelpingSpouseWithDepression />;
}
